exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor {\n  position: relative;\n  min-height: 90px;\n}\n.editor .add-comment {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n}", ""]);

// exports
